<template>
<div class="tw_dashboard_comments" :class="{edit: isEditMode, disabled: isDisabled}">
  <tw-table-system :schemas="schemas" :height="272" :nopager="true" :items="chats" @row-click="showDetail" />
</div>
</template>

<script>
import _ from 'lodash';
import { $api } from '@/store/ApiClient';
import { processNames } from '@/dictionaries/map.js';
import { getProcessNumber } from '@/utils/entity';
import TwTableSystem from '@/components/organisms/TwTableSystem';
import schemas from '@/dictionaries/dashBoardCommentsSchema.json';

export default {
  name: 'TwDashBoardComments',
  props: {
    isEditMode: Boolean,
    isDisabled: Boolean,
  },
  components: {
    TwTableSystem
  },
  data() {
    return {
      schemas: schemas,
      editor: null,
      content: '',
      options: {always: true, smooth: false},
      open: true,
      chats: null,
    }
  },
  computed: {
    userId() {
      return this.$store.state.userId;
    },
  },
  created() {
    this.fetch();
  },
  methods: {
    fetch() {
      // bff_db_5 コメント取得
      const params = {
        lslConfig: {
          serviceCode: 'tw-transaction-bff-api',
          apiCode: 'get_/v1/dashboard/comment',
        }
      };

      $api
        .request(params)
        .then(res => {
          this.chats = _.orderBy(res.chats, ['createDate'], ['desc']);
        })
        .catch(err => {
          this.chats = [];
          this.$store.dispatch('SHOW_ALERT', err.message);
        });
    },
    getProcessName(processId) {
      return _.get(processNames[processId.replace(/\d/g, '')], 'nameExShort') + getProcessNumber(processId);
    },
    getLink(comment) {
      return {
        name: `Process${_.capitalize(comment.processId.replace(/\d/g, ''))}`,
        params: { entityId: comment.entityId, processSeq: comment.processSeq, _processId: comment.processId.toLowerCase() },
      };
    },
    isToYou(chatDestinations) {
      return _.some(chatDestinations, {userIdTo: this.userId});
    },
    showDetail(comment) {
      this.$router.push(this.getLink(comment));
    }
  }
};
</script>

<style lang="scss" scoped>
  .tw_dashboard_comments {
    position: relative;
    z-index: 2;

    &.edit {
      pointer-events: none;

      &.disabled:after {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(249, 249, 253, 0.5);
        border-radius: 8px;
        content: '';
      }
    }
  }
</style>